import React, { useEffect, useRef, useState } from "react";
import styles from "./FounderSection.module.css";

// Replace these with your R2 URLs once uploaded
const FOUNDER_MAIN = "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/founderimages/IMG_0745.JPG.jpeg"; // seated, moody warm portrait
const FOUNDER_ACCENT = "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/founderimages/IMG_0742.JPG.jpeg"; // velvet shirt, carpet backdrop

const FounderSection = () => {
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setVisible(true);
            },
            { threshold: 0.15 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <section
            ref={sectionRef}
            className={`${styles.wrapper} ${visible ? styles.show : ""}`}
        >
            <div className={styles.container}>
                <div className={styles.grid}>

                    {/* ===== IMAGE COLUMN ===== */}
                    <div className={styles.imageColumn}>
                        <div className={styles.mainImage}>
                            <img src={FOUNDER_MAIN} alt="Siddhant Dhuwali, Founder of Baglami" />
                        </div>
                        <div className={styles.accentImage}>
                            <img src={FOUNDER_ACCENT} alt="Siddhant Dhuwali portrait" />
                        </div>
                    </div>

                    {/* ===== CONTENT COLUMN ===== */}
                    <div className={styles.content}>
                        <p className={`${styles.eyebrow} ${styles.fade}`}>The Founder</p>

                        <h2 className={`${styles.name} ${styles.fade} ${styles.d1}`}>
                            Siddhant Dhuwali
                        </h2>

                        <p className={`${styles.role} ${styles.fade} ${styles.d2}`}>
                            Founder &amp; Visionary
                        </p>

                        <blockquote className={`${styles.quote} ${styles.fade} ${styles.d3}`}>
                            <span className={styles.quoteMark}>&ldquo;</span>
                            Every space tells a story. Ours is one of exceptional hospitality,
                            meaningful connections, and a commitment to bringing people together.
                        </blockquote>

                        <div className={`${styles.divider} ${styles.fade} ${styles.d3}`}></div>

                        <p className={`${styles.bio} ${styles.fade} ${styles.d4}`}>
                            Driven by a passion for hospitality and design, Siddhant set out to
                            create a brand that blends world-class design, elevated hospitality,
                            and immersive dining experiences under one roof.
                        </p>

                        <p className={`${styles.bio} ${styles.fade} ${styles.d5}`}>
                            Guided by innovation, creativity, and an unwavering commitment to
                            excellence, he continues to lead Baglami with a vision to redefine
                            luxury hospitality in India &mdash; while building a globally
                            recognized Indian hospitality brand.
                        </p>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default FounderSection;